const NAMESPACE = "editNumericSettings";

const KEYS = {
    thousandSeparatorsHelptext: "thousandSeparatorsHelptext",
    thousandSeparatorsLabel: "thousandSeparatorsLabel",
    numericSettingScopeNote: "numericSettingScopeNote"
};

const MESSAGES = {
    [KEYS.thousandSeparatorsHelptext]: {
        value:
            "If this setting is enabled, this field will be displayed with comma separators everywhere it " +
            "appears in PowerClerk. For example, the value 10000 will be displayed as 10,000. " +
            "This will not affect any existing formulas or visibility rules.",
        comment:
            "Help text for toggle that allows users to specify that a numeric field should include separators " +
            "when sufficiently large values are displayed."
    },
    [KEYS.thousandSeparatorsLabel]: {
        value: "Show Thousand Separators?",
        comment: "Label for toggle that enables thousands-place separators in large numeric values for the field."
    },
    [KEYS.numericSettingScopeNote]: {
        value: "NOTE: This change will take effect everywhere the value of this data field is displayed.",
        comment: "A note about where the thousands separator change will be displayed"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
